import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { getContent } from "@/services/api";

const ContentContext = createContext({
  content: null,
  loading: true,
  reload: () => {}
});

export function ContentProvider({ children }) {
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);

  const reload = useCallback(async () => {
    try {
      const data = await getContent();
      setContent(data);
    } catch (e) {
      console.error("Failed to load content", e);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { reload(); }, [reload]);

  return (
    <ContentContext.Provider value={{ content, loading, reload }}>
      {children}
    </ContentContext.Provider>
  );
}

export function useContent() {
  return useContext(ContentContext);
}
